// extracted by mini-css-extract-plugin
module.exports = {"images":"Images_images__6r4OG","carouselPrevBtn":"Images_carouselPrevBtn__Wj_Ey","carouselNextBtn":"Images_carouselNextBtn__x1_n4"};